import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { IoIosArrowDropdown } from "react-icons/io";
import { MdLock } from "react-icons/md";
import {
  Alert,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Modal,
  OutlinedInput,
} from "@mui/material";
import SuccessBackground from "../../../asesst/SuccessBackground.svg";
import Tick from "../../../asesst/tick.svg";
import { RxCrossCircled } from "react-icons/rx";
import { ADMIN_PROFILE, DASHBOARD } from "../../utils/RouteConstant";
import { useNavigate } from "react-router";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { CgProfile } from "react-icons/cg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { changeAdminPassword } from "../../../redux/action/Auth/ForgetPasswordAction";
import { useDispatch, useSelector } from "react-redux";
import { GetProfileDetails } from "../../../redux/action/Profile/AdminProfileAction";
import { ImageBaseUrl } from "../../utils/helperData";

const settings = [
  { name: "Profile", icon: <CgProfile />, color: "black", action: "profile" },
  {
    name: "Change Password",
    icon: <MdLock />,
    color: "black",
    action: "changePassword",
  },
];

function NavBar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { user } = useSelector((state) => state.auth);
  const { adminprofileDetails } = useSelector((state) => state.profile);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    dispatch(GetProfileDetails());
  }, [dispatch]);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenSaveModal = (content) => {
    setModalContent(content);
    setOpenSaveModal(true);
  };

  const resetPasswordFields = () => {
    formik.resetForm();
    setErrorMessage("");
    setShowPassword1(false);
    setShowPassword2(false);
    setShowPassword3(false);
  };

  const handleCloseSaveModal = () => {
    setOpenSaveModal(false);
    setModalContent("");
    resetPasswordFields();
  };

  const handleDasshardModal = () => {
    setOpenSuccessModal(false);
    navigate(DASHBOARD);
  };

  const handleMenuItemClick = (action) => {
    switch (action) {
      case "changePassword":
        handleOpenSaveModal("changePassword");
        break;
      case "profile":
        navigate(ADMIN_PROFILE);
        break;
      default:
        break;
    }
    handleCloseUserMenu();
  };

  const handlePasswordSuccess = () => {
    setOpenSuccessModal(true);
    handleCloseSaveModal();
  };

  const handleCloseSuccessModal = () => {
    setOpenSuccessModal(false);
    resetPasswordFields();
  };

 const validationSchema = Yup.object({
   oldPassword: Yup.string()
     .required("Current password is required")
     .min(8, "Password must be at least 8 characters"),
   newPassword: Yup.string()
     .required("New password is required")
     .min(8, "Password must be at least 8 characters")
     .max(64, "Password must be no more than 64 characters")
     .matches(/[a-z]/, "Password must contain at least one lowercase letter")
     .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
     .matches(/[0-9]/, "Password must contain at least one digit")
     .matches(/[@$!%*?&#.]/, "Password must contain at least one special character")
     .matches(/^\S*$/, "Password must not contain spaces")
     .test( "no-consecutive-chars", "Password must not contain more than 2 consecutive identical characters",
       (value) => !/(.)\1{2,}/.test(value || "")
     ),
   confirmPassword: Yup.string()
     .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
     .required("Please confirm your password"),
 });

  const handleSubmit = async (values) => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched({
        oldPassword: true,
        newPassword: true,
        confirmPassword: true,
      });
      return;
    }

    try {
      const response = await changeAdminPassword(values.oldPassword, values.newPassword, dispatch);
      if (response.success) {
        handlePasswordSuccess();
      } else {
        setErrorMessage(response.message || "Failed to change password. Please try again.");
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "An error occurred. Please try again later.");
    }
  };


 const formik = useFormik({
   initialValues: {
     oldPassword: "",
     newPassword: "",
     confirmPassword: "",
   },
   validationSchema,
   onSubmit: handleSubmit,
 });

  const renderPasswordInput = (
    label,
    showPassword,
    handleClickShowPassword,
    formikField,
  ) => (
    <FormControl
      sx={{ m: 1, width: "100%" }}
      variant="outlined"
      style={{ marginTop: "7%" }}
    >
      <InputLabel htmlFor={`outlined-adornment-${label}`}>{label}</InputLabel>
      <OutlinedInput
        style={{ borderRadius: "12px" }}
        id={`outlined-adornment-${label}`}
        type={showPassword ? "text" : "password"}
        {...formik.getFieldProps(formikField)}
        error={
          formik.touched[formikField] && Boolean(formik.errors[formikField])
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />

      {formik.touched[formikField] && formik.errors[formikField] && (
        <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
          {formik.errors[formikField]}
        </p>
      )}
    </FormControl>
  );

  const renderModalContent = () => {
    if (modalContent === "changePassword") {
      return (
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <div className="bg-white flex  justify-between">
            <div className="justify-start text-start">
              <p className="text-lg font-semibold">Change Password</p>
              <p className="text-gray-500 text-sm">
                Fill the form below to change your account password.
              </p>
            </div>
            <div>
              <RxCrossCircled
                onClick={handleCloseSaveModal}
                className="float-end top-2 h-6 w-6 cursor-pointer"
              />
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            {errorMessage && (
              <Alert severity="error" className="mb-4 mt-4">
                {errorMessage}
              </Alert>
            )}
           {renderPasswordInput("Current Password", showPassword1, () => setShowPassword1(!showPassword1), "oldPassword")}
            {renderPasswordInput("New Password", showPassword2, () => setShowPassword2(!showPassword2), "newPassword")}
            {renderPasswordInput("Confirm New Password", showPassword3, () => setShowPassword3(!showPassword3), "confirmPassword")}
            <div className="mt-6 flex justify-end gap-4">
              <button
                type="button"
                onClick={handleCloseSaveModal}
                className="bg-gray-300 px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="submit"
                 disabled={!formik.isValid || formik.isSubmitting}
                className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
              >
                Update Password
              </button>
            </div>
          </form>
        </Box>
      );
    }
    return null;
  };

  const profilePicUrl = adminprofileDetails?.result?.profile_pic
    ? `${ImageBaseUrl}${adminprofileDetails?.result?.profile_pic}`
    : null;

  const firstName =
    user?.first_name || adminprofileDetails?.result?.first_name || "";
  const lastName =
    user?.last_name || adminprofileDetails?.result?.last_name || "";
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;

  return (
    <>
      <AppBar position="static" style={{ backgroundColor: "white" }}>
        <Container maxWidth="full">
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            <Typography variant="h6" noWrap component="div">
              {" "}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <IconButton>
                <Avatar
                  alt="Akshay Sharma"
                  src={profilePicUrl || `${ImageBaseUrl}${user?.profile_pic}`}
                  style={
                    !profilePicUrl
                      ? {
                          backgroundColor: "#404040",
                          color: "#FFFFFF",
                          fontWeight: 600,
                          width: 40,
                          height: 40,
                        }
                      : undefined
                  }
                >
                  {profilePicUrl ? null : initials}
                </Avatar>
              </IconButton>
              <Typography>
                <span style={{ fontWeight: 600, color: "#404040" }}>
                  {user?.first_name || adminprofileDetails?.result?.first_name}{" "}
                  {user?.last_name || adminprofileDetails?.result?.last_name}
                </span>{" "}
                <br />
                <span style={{ fontWeight: 500, color: "#565656" }}>Admin</span>
              </Typography>

              <Tooltip title="Open Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <IoIosArrowDropdown />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "42px", width: "100%" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting.name}
                    onClick={() => handleMenuItemClick(setting.action)}
                  >
                    <ListItemIcon>{setting.icon}</ListItemIcon>
                    <ListItemText style={{ color: setting.color }}>
                      {setting.name}
                    </ListItemText>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {modalContent && (
        <Modal open={openSaveModal} className="justify-center items-center">
          {renderModalContent()}
        </Modal>
      )}

      <Modal open={openSuccessModal} className="justify-center items-center">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <RxCrossCircled
            onClick={handleCloseSuccessModal}
            className="float-end top-2 h-6 w-6 cursor-pointer"
          />
          <div className="text-center inline-flex mt-6">
            <div
              className="w-[72px] h-[72px] flex items-center justify-center"
              style={{ backgroundImage: `url(${SuccessBackground}` }}
            >
              <img src={Tick} alt="Success" className="w-7 h-7" />
            </div>
          </div>
          <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
            Success
          </p>
          <span className="text-[#6D6D6D]">Password update successfully!</span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={handleCloseSuccessModal}
              className="bg-gray-300 px-4 py-2 rounded-lg"
            >
              Close
            </button>
            <button
              onClick={handleDasshardModal}
              className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
            >
              Dashboard
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default NavBar;
